import Model from './Model'

// Live company job postings as a tradie sees them (the job board). Query params
// map cleanly: where('q', x) -> filter[q]=x, where('trade_id', x) ->
// filter[trade_id]=x.
export default class JobBoardPosting extends Model {
  resource() {
    return 'jobs-board'
  }

  // The API paginates with `per_page`, not vue-api-query's default `limit`.
  parameterNames() {
    return {
      ...super.parameterNames(),
      limit: 'per_page',
    }
  }
}
